import arrayToTree from 'array-to-tree';
import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../components/snackBar/snakbar';
import { MoneyFormatv3 } from '../library/MoneyFormat';
import { store } from '../redux/store';


export const addCacheBuster = (url) => {
  const timestamp = Date.now();
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}t=${timestamp}`;
};

export const capitalizeFirstLetter = (string) => {
  return string?.charAt(0)?.toUpperCase() + string?.slice(1)?.toLowerCase();
};
export const capitalizeFirstLetters = (inputString) => {
  const wordsArray = inputString?.split?.(' ') ?? [];
  const capitalizedString = wordsArray.map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()).join(' ');
  return capitalizedString;
};

export const capitalizeWords = (str) => {
  return str?.replace?.(/\b\w/g, (char) => char.toUpperCase()) ?? str;
};
export const defaultRowsPerPageOptions = [15, 25, 50, 100, 250, 500];
export const defaultRowsPerPage = 25;
export const defaultSortingOrder = 'desc';
export const defaultSortingColumn = 'enteredtimestamp';
export const defaultSortingDetails = {
  items: { defaultSortingOrder, defaultSortingColumn: 'itemid' },
  party: { defaultSortingOrder, defaultSortingColumn: 'partyid' }, // suppliers and customers
  sales: { defaultSortingOrder, defaultSortingColumn: 'InvoiceDateTimeStamp' },
  purchase: { defaultSortingOrder, defaultSortingColumn: 'EntryDate' },
  crdrnote: { defaultSortingOrder, defaultSortingColumn: 'CrDrNoteDate' }, // credit note and debit note
  voucher: { defaultSortingOrder, defaultSortingColumn: 'EntryDate' }, // receipt, payments and journal
};
export const getDefaultSorting = (pageName) => {
  return defaultSortingDetails[pageName] || { defaultSortingOrder, defaultSortingColumn };
};
export const isPromise = (value) => {
  return Boolean(value && typeof value.then === 'function');
};
export const supportedImageFileTypes = ['image/jpeg', 'image/png', 'image/jpg'];
export const supportedFileTypes = [
  ...supportedImageFileTypes,
  'application/pdf', // PDF
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // DOCX
  'application/msword', // DOC (Word 97-2003)
  'application/vnd.ms-excel', // XLS (Excel 97-2003)
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // XLSX
  'text/csv', // CSV
  'text/plain', // TXT
  'application/vnd.ms-powerpoint', // PPT (PowerPoint 97-2003)
  'video/mp4', // MP4
  'video/quicktime', // MOV
  'video/x-msvideo', // AVI
  'video/x-matroska', // MKV
  'video/webm', // WEBM
];
export const handleFreeze = () => showWarningSnackbar('Financial Year Is Frozen. You cannot Do this action now.');
export const trimEdgesOnly = (str) => str.replace(/^\s+|\s+$/g, '');
export const formatNumber = (value, showDrCr = false, formatAsMoney = false, balanceSign) => {
  console.log({ value, balanceSign });
  let formattedValue = Math.abs(value);
  if (formatAsMoney) formattedValue = MoneyFormatv3(formattedValue);
  if (showDrCr && value != 0) formattedValue += (balanceSign === -1 ? value < 0 : value > 0) ? ' Cr' : ' Dr';
  return formattedValue;
};

/**
 * Removes duplicate place-of-supply key from return data (e.g. B2C small).
 * When both placeOfSupply (camelCase) and placeofsupply (lowercase) exist, keeps only placeofsupply.
 * @param {Object} row - Single row/object that may have both placeOfSupply and placeofsupply
 * @returns {Object} - New object without the duplicate key (placeOfSupply removed)
 */
export const normalizePlaceOfSupplyRow = (row) => {
  if (!row || typeof row !== 'object') return row;
  if (!('placeOfSupply' in row) || !('placeofsupply' in row)) return row;
  const { placeOfSupply, ...rest } = row;
  return rest;
};

/**
 * Normalizes an array of rows (e.g. B2C small return data) to remove placeOfSupply/placeofsupply duplication.
 * @param {Array} rows - Array of row objects
 * @returns {Array} - New array with each row normalized (only placeofsupply kept)
 */
export const normalizePlaceOfSupplyReturnData = (rows) => {
  if (!Array.isArray(rows)) return rows;
  return rows.map(normalizePlaceOfSupplyRow);
};

export const checkPdfStatus = (url) => {
  const path = url.match(/(?<=https?:\/\/[^\/]+\/).*/);
  let data = store.getState()?.pdfStatus?.[path];
  console.log(data, '====>data');
  if (data?.status === 'pending' && data?.startedAt && Date.now() - new Date(data?.startedAt).getTime() < 60 * 1000) {
    return false;
  } else {
    return true;
  }
};

export const checkandopenpdf = (url) => {
  if (!url) return;
  if (!checkPdfStatus(url)) {
    return showWarningSnackbar('Pdf is not ready yet, please try again later');
  }
  window.open(addCacheBuster(url), '_blank');
};

export async function fetchAndPrintPDF(pdfUrl) {
  console.log(pdfUrl, '====>inside fetch and print pdf');
  if (!pdfUrl) return;
  if (!checkPdfStatus(pdfUrl)) {
    return showWarningSnackbar('Pdf is not ready yet, please try again later');
  }

  try {
    const response = await fetch(addCacheBuster(pdfUrl));
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isMobile) {
      window.open(blobUrl, "_blank");
      return;
    }

    if (document.getElementById('pdfFrame')) {
      document.body.removeChild(document.getElementById('pdfFrame'));
    }
    const iframe = document.createElement('iframe');
    iframe.id = 'pdfFrame';
    iframe.style.display = 'none';
    iframe.style.width = '0';
    iframe.style.height = '0';
    document.body.appendChild(iframe);
    iframe.src = blobUrl;
    iframe.onload = function () {
      iframe.style.display = 'block';
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      iframe.contentWindow.print();
      iframe.style.display = 'none';
      iframe.style.width = '0';
      iframe.style.height = '0';
      URL.revokeObjectURL(blobUrl);
    };
  } catch (error) {
    console.error('Error fetching or printing PDF:', error);
  }
}

export function constructNewObject(obj, query) {
  // Extract field names from the query, maintaining the original case
  const fieldRegex = /\b(\w+)\b/g;
  const queryFields = {};
  let match;

  while ((match = fieldRegex.exec(query)) !== null) {
    queryFields[match[1].toLowerCase()] = match[1];
  }

  function recursiveTransform(currentObj) {
    if (Array.isArray(currentObj)) {
      return currentObj.map((item) => recursiveTransform(item));
    } else if (typeof currentObj === 'object' && currentObj !== null) {
      const transformedObj = {};
      for (const key in currentObj) {
        const lowerCaseKey = key.toLowerCase();
        // Check if the key (in lowercase) exists in the query fields
        const newKey = queryFields[lowerCaseKey] || key; // Keep the original key if no match found
        transformedObj[newKey] = recursiveTransform(currentObj[key]); // Recurse for nested structures
      }
      return transformedObj;
    }
    return currentObj;
  }

  return recursiveTransform(obj);
}

export function lowercaseKeys(input) {
  if (Array.isArray(input)) {
    // If input is an array, map through each item and apply the function recursively
    return input.map((item) => lowercaseKeys(item));
  } else if (typeof input === 'object' && input !== null) {
    // If input is an object, create a new object with lowercase keys
    return Object.keys(input).reduce((acc, key) => {
      const lowerCaseKey = key.toLowerCase();
      acc[lowerCaseKey] = lowercaseKeys(input[key]); // Recur for nested structures
      return acc;
    }, {});
  }
  // Return the input as is if it's neither an array nor an object
  return input;
}
export function getCookie(name) {
  const cookies = document.cookie.split('; '); // Split cookies into individual key=value pairs
  for (let cookie of cookies) {
    const [key, value] = cookie.split('='); // Split key and value
    if (key === name) {
      return decodeURIComponent(value); // Return the decoded value if the key matches
    }
  }
  return null; // Return null if the cookie is not found
}
export const handleCreateLedger = async (
  createAccountMaster,
  createAccountGSTDetails,
  data,
  gstData,
  refetchAccountOpeningBalance,
  setNewLedgerResponse
) => {
  try {
    const responseAm = await createAccountMaster({
      createAccountMasterInput: data,
    }).unwrap();
    setNewLedgerResponse((prev) => [...prev, responseAm?.data?.accountsid]);
    if (gstData) {
      const gstDetails = {
        accountid: responseAm?.data?.accountsid,
        effectivedate: gstData.effectivedate,
        expireddate: gstData.expireddate,
        gstcompensationtype: gstData.cessType,
        gstrate: Number(gstData.gstRate),
        hsnid: gstData.hsnid,
        cessamount: gstData.cess == '' ? 0 : Number(gstData.cess),
      };
      const responseGS = await createAccountGSTDetails({ createAccountGSTDetailsInput: gstDetails });
    }
    refetchAccountOpeningBalance();
    showSuccessSnackbar('Ledger Created Successfully');
  } catch (error) {
    showErrorSnackbar('Error Creating Ledger');
  }
};
export const isMobileDevice = () => /Mobi|Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent);

export const getZoomLevel = () => window.devicePixelRatio || 1;

function generateRandomId() {
  return 'id-' + Date.now().toString(36) + Math.random().toString(36).substring(2, 10);
}

/**
 * Sorts an array of items so that ledgers appear before groups.
 * Within groups, sorts by displayordernumber (Bank OD last under Current Liabilities).
 * @param {Array} items - Array of items with category property
 * @returns {Array} - Sorted array with ledgers first, then groups by displayordernumber
 */
export const sortChildrenLedgersFirst = (items) => {
  if (!Array.isArray(items)) return items;
  return [...items].sort((a, b) => {
    const aIsLedger = a.category === 'ledger';
    const bIsLedger = b.category === 'ledger';
    // Ledgers come first
    if (aIsLedger && !bIsLedger) return -1;
    if (!aIsLedger && bIsLedger) return 1;
    // Ledgers: A-Z by name
    if (aIsLedger && bIsLedger) {
      return (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase());
    }
    // Groups: sort by displayordernumber (Bank OD last)
    const orderA = a.displayordernumber ?? 999;
    const orderB = b.displayordernumber ?? 999;
    return orderA - orderB;
  });
};

/**
 * Sort account tree at each level: restricted first, ledgers then groups, then A-Z by name.
 * Same order as Dashboard Trade receivables/payables.
 */
export const sortAccountTreeAlphabetically = (tree) => {
  if (!Array.isArray(tree)) return tree;
  return tree.map((node) => {
    if (node.children?.length > 0) {
      return {
        ...node,
        children: sortAccountTreeAlphabetically(
          [...node.children].sort((a, b) => {
            const isRestrictedA = a.restrictedflag === 1;
            const isRestrictedB = b.restrictedflag === 1;
            if (isRestrictedA && isRestrictedB) return 0;
            if (isRestrictedA) return -1;
            if (isRestrictedB) return 1;
            const categoryA = a.category || (a.type === 'Account' ? 'ledger' : 'group');
            const categoryB = b.category || (b.type === 'Account' ? 'ledger' : 'group');
            if (categoryA !== categoryB) return categoryA === 'ledger' ? -1 : 1;
            return (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase());
          })
        ),
      };
    }
    return node;
  });
};

export const recalculateGroupBalances = (data) => {
  let overallTotalBalance = 0;
  let overallTotalDebit = 0;
  let overallTotalCredit = 0;
  if (!Array.isArray(data)) return { updatedData: data ?? [], totalBalance: 0, totalDebit: 0, totalCredit: 0 };

  data.forEach((group) => {
    if (group?.category === 'group' || group?.category === 'profitability') {
      const groupTotals = processGroupNode(group);
      overallTotalBalance += groupTotals?.total ?? 0;
      overallTotalDebit += groupTotals?.totalDebit ?? 0;
      overallTotalCredit += groupTotals?.totalCredit ?? 0;
    }
  });

  return {
    updatedData: data,
    totalBalance: overallTotalBalance,
    totalDebit: overallTotalDebit,
    totalCredit: overallTotalCredit,
  };
};

export const constructHierarchicalAccountTree = (accountData, excludedGroups, excludedLedgers, anotherAccounts, totalClosingStock) => {
  try {
    if (!Array.isArray(accountData)) return [];
    const { total_closing_amount = 0 } = totalClosingStock?.[0] || {};
    const gstPriorityOrder = { IGST: 1, CGST: 2, SGST: 3, UGST: 4 };

    let openingBalanceDiff, totalTradingExpense, openingStock;
    let forceDisplayGroups = [];

    const sortedAccounts = [...accountData].sort((accountA, accountB) => {
      const nameA = accountA?.accountname || accountA?.accountgroupname || '';
      const nameB = accountB?.accountname || accountB?.accountgroupname || '';
      const orderA = gstPriorityOrder[nameA?.split?.(' ')?.[0]] || 999;
      const orderB = gstPriorityOrder[nameB?.split?.(' ')?.[0]] || 999;

      const isRestrictedA = accountA.restrictedflag === 1;
      const isRestrictedB = accountB.restrictedflag === 1;

      if (orderA !== 999 && orderB !== 999) return orderA - orderB;
      if (orderA !== 999) return -1;
      if (orderB !== 999) return 1;

      if (isRestrictedA && isRestrictedB) return 0;
      if (isRestrictedA) return -1;
      if (isRestrictedB) return 1;

      const categoryA = accountA.type === 'Account' ? 'ledger' : 'group';
      const categoryB = accountB.type === 'Account' ? 'ledger' : 'group';

      if (categoryA !== categoryB) return categoryA === 'ledger' ? -1 : 1;

      return (nameA ?? '').toLowerCase().localeCompare((nameB ?? '').toLowerCase());
    });

    const nodes = sortedAccounts
      .map((entry) => {
        if (entry.type === 'Account') {
          if (entry.accountid === 12 && entry?.accounttypecd === 'BS') {
            openingBalanceDiff = {
              category: 'ledger',
              groupName: entry?.immediate_parent_group_name,
              name: entry?.accountname,
              id: entry?.accountid,
              _id: entry?.accountid + 'ledger',
              key: generateRandomId(),
              parent: entry?.immediate_parent_group_id,
              balance: entry?.balance,
              restrictedflag: entry?.restrictedflag,
              type: entry?.accounttypecd,
              credit: entry?.creditamount || 0,
              debit: entry?.debitamount || 0,
              balancesign: entry?.balancesign,
              is_active: entry?.is_active,
              accounttypeflag: entry?.accounttypeflag || 0,
            };
            return null;
          }

          if (entry.accountid === 24 && entry?.accounttypecd === 'PandL') {
            openingStock = {
              category: 'ledger',
              groupName: entry?.immediate_parent_group_name,
              name: entry?.accountname,
              id: entry?.accountid,
              _id: entry?.accountid + 'ledger',
              key: generateRandomId(),
              parent: entry?.immediate_parent_group_id,
              balance: entry?.balance,
              restrictedflag: entry?.restrictedflag,
              type: entry?.accounttypecd,
              credit: entry?.creditamount || 0,
              debit: entry?.debitamount || 0,
              balancesign: entry?.balancesign,
              is_active: entry?.is_active,
              accounttypeflag: entry?.accounttypeflag || 0,
            };
          }
          if (entry.accountid === 40 && entry?.accounttypecd === 'PandL') {
            return null;
          }

          const isLedgerExcluded =
            excludedLedgers?.includes(entry?.accountid) || excludedGroups?.includes(entry?.immediate_parent_group_id);
          const hasBalance = entry?.balance !== 0;
          const isActive = entry?.is_active === 1;

          if (isLedgerExcluded && hasBalance) {
            const segment = entry?.group_path?.split('/').filter(Boolean);
            if (!forceDisplayGroups?.some((existingSegment) => JSON.stringify(existingSegment) === JSON.stringify(segment))) {
              forceDisplayGroups.push(segment);
            }
          }

          if (!(isLedgerExcluded && !hasBalance) && (isActive || hasBalance)) {
            const ID = entry?.accountid || entry?.accountsid;
            const balance = ID === 23 ? total_closing_amount : entry?.balance;
            return {
              category: 'ledger',
              groupName: entry?.immediate_parent_group_name,
              name: entry?.accountname,
              id: ID,
              _id: `${ID}ledger`,
              key: generateRandomId(),
              parent: entry?.immediate_parent_group_id || entry?.accountgroupid,
              balance,
              restrictedflag: entry?.restrictedflag,
              type: entry?.accounttypecd,
              credit: entry?.creditamount || 0,
              debit: entry?.debitamount || 0,
              path: entry?.group_path,
              balancesign: entry?.balancesign,
              is_active: entry?.is_active,
              accounttypeflag: entry?.accounttypeflag || 0,
            };
          }
        } else {
          const isGroupExcluded = excludedGroups?.includes(entry.accountgroupid);
          const isParentInForceDisplayGroups = forceDisplayGroups?.some((existingSegment) =>
            existingSegment.includes(entry.accountgroupid?.toString())
          );

          const segment = entry?.path?.split('/').filter(Boolean);
          const balancesign = segment?.some((item) => ['1', '18', '22', '24'].includes(item)) ? 1 : -1;

          if (!isGroupExcluded || isParentInForceDisplayGroups) {
            const parentIdMap = { 26: 'EBITDA', 27: 'EBIT', 28: 'PBT' };
            const parentId =
              parentIdMap[entry?.accountgroupid] ||
              (entry?.accountparentgroupid !== entry?.accountgroupid ? entry?.accountparentgroupid : null);

            return {
              category: 'group',
              groupName: '',
              name: entry?.accountgroupname,
              id: entry?.accountgroupid,
              _id: entry?.accountgroupid,
              key: generateRandomId(),
              parent: parentId,
              balance: entry?.balance || 0,
              restrictedflag: entry?.restrictedflag,
              type: entry?.accounttypecd,
              credit: 0,
              debit: 0,
              is_active: entry?.is_active,
              balancesign,
              path: entry?.accountgroupid === 46 ? entry?.path + 'p2/' : entry?.path,
              displayordernumber: entry?.displayordernumber ?? entry?.accountgroupdisplayordernumber,
            };
          }
        }
      })
      .filter(Boolean);

    if (anotherAccounts?.length > 0) {
      nodes.push(...anotherAccounts);
    }

    const accountTree = arrayToTree(nodes, {
      parentProperty: 'parent',
      customID: '_id',
    });



    const sortChildrenAlphabetically = (tree) => {
      return tree.map((node) => {
        if (node.children?.length > 0) {
          return {
            ...node,
            children: sortChildrenAlphabetically(
              node.children.sort((a, b) => {
                const isRestrictedA = a.restrictedflag === 1;
                const isRestrictedB = b.restrictedflag === 1;

                if (isRestrictedA && isRestrictedB) return 0;
                if (isRestrictedA) return -1;
                if (isRestrictedB) return 1;

                const categoryA = a.category || (a.type === 'Account' ? 'ledger' : 'group');
                const categoryB = b.category || (b.type === 'Account' ? 'ledger' : 'group');

                if (categoryA !== categoryB) return categoryA === 'ledger' ? -1 : 1;

                // Sort groups by displayordernumber (Bank OD last under Current Liabilities)
                if (categoryA === 'group' && categoryB === 'group') {
                  const orderA = a.displayordernumber ?? 999;
                  const orderB = b.displayordernumber ?? 999;
                  return orderA - orderB;
                }
                return (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase());
              })
            ),
          };
        }
        return node;
      });
    };

    const sortedAccountTree = sortChildrenAlphabetically(accountTree);
    const { updatedData, totalDebit, totalCredit, totalBalance } = recalculateGroupBalances(sortedAccountTree);

    return {
      updatedAccountTree: updatedData,
      openingBalanceDiff,
      totalTradingExpense,
      openingStock,
      totalDebit,
      totalCredit,
      totalBalance,
    };
  } catch (error) {
    return [];
  }
};

function processGroupNode(group) {
  let totalBalance = 0;
  let totalDebitBalance = 0;
  let totalCreditBalance = 0;

  if (group?.children?.length > 0) {
    group.children.forEach((child) => {
      if (child?.category === 'ledger') {
        totalBalance += child?.balance ?? 0;
        totalDebitBalance += child?.balancesign === -1 ? (child?.balance ?? 0) : 0;
        totalCreditBalance += child?.balancesign === 1 ? (child?.balance ?? 0) : 0;
      } else {
        const childTotals = processGroupNode(child);
        totalBalance += childTotals?.total ?? 0;
        totalDebitBalance += childTotals?.totalDebit ?? 0;
        totalCreditBalance += childTotals?.totalCredit ?? 0;
      }
    });
  }

  if (group?.category === 'group' || group?.category === 'profitability') {
    group.balance = totalBalance;
    group.credit = totalCreditBalance;
    group.debit = totalDebitBalance;
  }

  return {
    total: totalBalance,
    totalDebit: totalDebitBalance,
    totalCredit: totalCreditBalance,
  };
}



export const searchInAccountTree = (tree, searchText, sortBy) => {
  try {
    if (!tree || !Array.isArray(tree)) return [];
    const searchTree = (nodes, searchText, uniqueSet, path) => {
      const results = [];
      if (!Array.isArray(nodes)) return results;
      nodes.forEach((node) => {
        const currentPath = (node?._id ?? '') + (node?.name ?? '');
        const nameMatch = node?.name?.toLowerCase?.()?.includes?.(searchText?.toLowerCase?.());

        if (nameMatch && !uniqueSet.has(currentPath)) {
          results.push(node);
          uniqueSet.add(currentPath);
        }

        if (node.children && node.children.length > 0) {
          const childMatches = searchTree(node.children, searchText, uniqueSet, currentPath);
          results.push(...childMatches);
        }
      });

      return results;
    };

    const uniqueSet = new Set();
    const searchResults = searchTree(tree, searchText, uniqueSet, '');

    // Optional: Filter by category
    const filteredResults =
      sortBy && sortBy.toLowerCase() !== 'all'
        ? searchResults.filter((node) => node.category && node.category.toLowerCase().includes(sortBy.toLowerCase()))
        : searchResults;

    // Sorting: Groups first, then Ledgers, then alphabetically within each category
    const sortedResults = filteredResults.sort((a, b) => {
      const categoryOrder = {
        group: 1, // Groups first
        ledger: 2, // Ledgers second
      };

      const aCategory = categoryOrder[a.category] || 3; // Default category rank
      const bCategory = categoryOrder[b.category] || 3;

      if (aCategory !== bCategory) {
        return aCategory - bCategory; // Sort by category priority
      }

      return (a?.name ?? '').toLowerCase().localeCompare((b?.name ?? '').toLowerCase()); // Sort alphabetically within category
    });

    return sortedResults;
  } catch (error) {
    console.error('Error searching in account tree:', error);
    return [];
  }
};

export const searchInAccountList = (flatList, searchText, sortBy) => {
  try {
    if (!Array.isArray(flatList)) return [];
    const lowerCaseSearchText = searchText?.toLowerCase?.() ?? '';
    let filteredResults = flatList.filter((node) => node?.name?.toLowerCase?.()?.includes?.(lowerCaseSearchText));

    if (sortBy && sortBy.toLowerCase() !== 'all') {
      const type = sortBy.toLowerCase();
      filteredResults = filteredResults.filter((node) => node?.category?.toLowerCase?.() === type);
    }

    const sortedResults = arrayToTree(filteredResults, {
      parentProperty: 'parent',
      customID: '_id',
    });

    const sortChildrenAlphabetically = (tree) => {
      if (!Array.isArray(tree)) return tree ?? [];
      return tree.map((node) => {
        if (node?.children?.length > 0) {
          return {
            ...node,
            children: sortChildrenAlphabetically(
              node.children?.sort?.((a, b) => {
                const isRestrictedA = a?.restrictedflag === 1;
                const isRestrictedB = b?.restrictedflag === 1;

                if (isRestrictedA && isRestrictedB) return 0;
                if (isRestrictedA) return -1;
                if (isRestrictedB) return 1;

                const categoryA = a?.category || (a?.type === 'Account' ? 'ledger' : 'group');
                const categoryB = b?.category || (b?.type === 'Account' ? 'ledger' : 'group');

                if (categoryA !== categoryB) return categoryA === 'ledger' ? -1 : 1;

                return (a?.name || '').toLowerCase().localeCompare((b?.name || '').toLowerCase());
              }) ?? node.children
            ),
          };
        }
        return node;
      });
    };

    return sortChildrenAlphabetically(sortedResults);
  } catch (error) {
    return [];
  }
};

export const cleanObjectArgs = (data) => {
  if (Array.isArray(data)) return data.map(cleanObjectArgs);
  if (typeof data === 'object' && data !== null) {
    return Object.keys(data).reduce((acc, key) => {
      acc[key] = cleanObjectArgs(data[key]);
      return acc;
    }, {});
  }
  return data === undefined ? '' : data;
};

export const currencies = {
  INR: { unit: 'Rupee', unitPlural: 'Rupees', subunit: 'Paisa', subunitPlural: 'Paise', symbol: '₹' },
  USD: { unit: 'Dollar', unitPlural: 'Dollars', subunit: 'Cent', subunitPlural: 'Cents', symbol: '$' },
  EUR: { unit: 'Euro', unitPlural: 'Euros', subunit: 'Cent', subunitPlural: 'Cents', symbol: '€' },
  GBP: { unit: 'Pound', unitPlural: 'Pounds', subunit: 'Penny', subunitPlural: 'Pence', symbol: '£' },
  JPY: { unit: 'Yen', unitPlural: 'Yen', subunit: 'Sen', subunitPlural: 'Sen', symbol: '¥' },
  CNY: { unit: 'Yuan', unitPlural: 'Yuan', subunit: 'Fen', subunitPlural: 'Fen', symbol: '¥' },
  AUD: { unit: 'Dollar', unitPlural: 'Dollars', subunit: 'Cent', subunitPlural: 'Cents', symbol: 'A$' },
  CAD: { unit: 'Dollar', unitPlural: 'Dollars', subunit: 'Cent', subunitPlural: 'Cents', symbol: 'C$' },
  CHF: { unit: 'Franc', unitPlural: 'Francs', subunit: 'Rappen', subunitPlural: 'Rappen', symbol: 'CHF' },
  RUB: { unit: 'Ruble', unitPlural: 'Rubles', subunit: 'Kopek', subunitPlural: 'Kopeks', symbol: '₽' },
  KRW: { unit: 'Won', unitPlural: 'Won', subunit: 'Jeon', subunitPlural: 'Jeon', symbol: '₩' },
  SEK: { unit: 'Krona', unitPlural: 'Kronor', subunit: 'Öre', subunitPlural: 'Öre', symbol: 'kr' },
  NOK: { unit: 'Krone', unitPlural: 'Kroner', subunit: 'Øre', subunitPlural: 'Øre', symbol: 'kr' },
  DKK: { unit: 'Krone', unitPlural: 'Kroner', subunit: 'Øre', subunitPlural: 'Øre', symbol: 'kr' },
  SGD: { unit: 'Dollar', unitPlural: 'Dollars', subunit: 'Cent', subunitPlural: 'Cents', symbol: 'S$' },
  HKD: { unit: 'Dollar', unitPlural: 'Dollars', subunit: 'Cent', subunitPlural: 'Cents', symbol: 'HK$' },
  NZD: { unit: 'Dollar', unitPlural: 'Dollars', subunit: 'Cent', subunitPlural: 'Cents', symbol: 'NZ$' },
  ZAR: { unit: 'Rand', unitPlural: 'Rand', subunit: 'Cent', subunitPlural: 'Cents', symbol: 'R' },
  MYR: { unit: 'Ringgit', unitPlural: 'Ringgit', subunit: 'Sen', subunitPlural: 'Sen', symbol: 'RM' },
  IDR: { unit: 'Rupiah', unitPlural: 'Rupiah', subunit: 'Sen', subunitPlural: 'Sen', symbol: 'Rp' },
  BRL: { unit: 'Real', unitPlural: 'Reais', subunit: 'Centavo', subunitPlural: 'Centavos', symbol: 'R$' },
  MXN: { unit: 'Peso', unitPlural: 'Pesos', subunit: 'Centavo', subunitPlural: 'Centavos', symbol: 'MX$' },
  ARS: { unit: 'Peso', unitPlural: 'Pesos', subunit: 'Centavo', subunitPlural: 'Centavos', symbol: 'AR$' },
  THB: { unit: 'Baht', unitPlural: 'Baht', subunit: 'Satang', subunitPlural: 'Satang', symbol: '฿' },
  PLN: { unit: 'Zloty', unitPlural: 'Zlotys', subunit: 'Grosz', subunitPlural: 'Groszy', symbol: 'zł' },
  TRY: { unit: 'Lira', unitPlural: 'Lira', subunit: 'Kurus', subunitPlural: 'Kurus', symbol: '₺' },
  SAR: { unit: 'Riyal', unitPlural: 'Riyals', subunit: 'Halala', subunitPlural: 'Halalas', symbol: '﷼' },
  AED: { unit: 'Dirham', unitPlural: 'Dirhams', subunit: 'Fils', subunitPlural: 'Fils', symbol: 'د.إ' },
  EGP: { unit: 'Pound', unitPlural: 'Pounds', subunit: 'Piastre', subunitPlural: 'Piastres', symbol: 'E£' },
  VND: { unit: 'Dong', unitPlural: 'Dong', subunit: 'Hao', subunitPlural: 'Hao', symbol: '₫' },
  NGN: { unit: 'Naira', unitPlural: 'Naira', subunit: 'Kobo', subunitPlural: 'Kobo', symbol: '₦' },
  PKR: { unit: 'Rupee', unitPlural: 'Rupees', subunit: 'Paisa', subunitPlural: 'Paise', symbol: '₨' },
  BDT: { unit: 'Taka', unitPlural: 'Taka', subunit: 'Poisha', subunitPlural: 'Poisha', symbol: '৳' },
};

export const TRANSACTION_CONFIG = {
  CreditNote: {
    path: 'viewcreditnote',
    getTransactionId: (data) => data?.crdrnoteid,
  },
  DebitNote: {
    path: 'viewdebitnote',
    getTransactionId: (data) => data?.crdrnoteid,
  },
  CashReceipt: {
    path: 'viewreceipts',
    getTransactionId: (data) => data?.transactionid,
  },
  BankReceipt: {
    path: 'viewreceipts',
    getTransactionId: (data) => data?.transactionid,
  },
  CashPayment: {
    path: 'viewpaymententries',
    getTransactionId: (data) => data?.transactionid,
  },
  BankPayment: {
    path: 'viewpaymententries',
    getTransactionId: (data) => data?.transactionid,
  },
  ManualJournal: {
    path: 'viewjournalentry',
    getTransactionId: (data) => data?.transactionid,
  },
  Journal: {
    path: 'viewjournalentry',
    getTransactionId: (data) => data?.transactionid,
  },
  PosInvoice: {
    path: 'viewpos',
    getTransactionId: (data) => data?.invoiceid,
  },
  SalesInvoice: {
    path: 'viewnewinvoicetax',
    getTransactionId: (data) => data?.invoiceid,
  },
  PurchaseInvoice: {
    path: 'viewnewpurchasetax',
    getTransactionId: (data) => data?.purchaseid,
  },
  OpeningBalance: {
    path: '',
    getTransactionId: (data) => data?.transactionid,
  },
};

/**
 * Sort siblings by restricted flag first, then for groups by displayordernumber (Bank OD last), then by path.
 */
function sortByRestrictedThenPath(a, b) {
  const isRestrictedA = a.restrictedflag === 1;
  const isRestrictedB = b.restrictedflag === 1;
  if (isRestrictedA !== isRestrictedB) return isRestrictedA ? -1 : 1;
  const aIsLedger = a.category === 'ledger';
  const bIsLedger = b.category === 'ledger';
  const aIsGroup = a.category === 'group';
  const bIsGroup = b.category === 'group';
  // Ledgers: A-Z by name
  if (aIsLedger && bIsLedger) {
    return (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase());
  }
  // Groups: sort by displayordernumber (Bank OD last)
  if (aIsGroup && bIsGroup) {
    const orderA = a.displayordernumber ?? 999;
    const orderB = b.displayordernumber ?? 999;
    if (orderA !== orderB) return orderA - orderB;
  }
  const pathA = (a.path || '').toString();
  const pathB = (b.path || '').toString();
  return pathA.localeCompare(pathB);
}

export const flattenTree = (tree, page, depth = 1, parentPath = [], parentSide = null) => {
  let flatList = [];
  const sortedTree = Array.isArray(tree) ? [...tree].sort(sortByRestrictedThenPath) : tree;

  sortedTree.forEach((node) => {
    let side = parentSide;

    if (page !== 'item') {
      if (depth === 0) {
        if (node.id === 1 || node.path?.includes(`/1/`)) {
          side = 'left';
        } else if (node.id === 10 || node.path?.includes(`/10/`)) {
          side = 'right';
        }
      }
    }

    const newPathArr = [...parentPath, node.id];

    let nodePath = node.path;
    if (page === 'item' && !node.path) {
      nodePath = `/${newPathArr.join('/')}`;
    }

    flatList.push({ ...node, depth, side, path: nodePath });

    if (node.children && node.children.length) {
      const sortedChildren = [...node.children].sort(sortByRestrictedThenPath);
      flatList = flatList.concat(flattenTree(sortedChildren, page, depth + 1, newPathArr, side));
    }
  });

  // Remove children key
  return flatList.map(({ children, ...rest }) => rest);
};

/**
 * Sort for Opening Balance: restricted first, ledgers A-Z, groups by displayordernumber (Bank OD last), then path.
 * Same logic as sortByRestrictedThenPath for consistency across all tabs.
 */
function sortLedgerFirstThenRestrictedThenPath(a, b) {
  const categoryA = a.category || (a.type === 'Account' ? 'ledger' : 'group');
  const categoryB = b.category || (b.type === 'Account' ? 'ledger' : 'group');
  const isRestrictedA = a.restrictedflag === 1;
  const isRestrictedB = b.restrictedflag === 1;
  if (isRestrictedA !== isRestrictedB) return isRestrictedA ? -1 : 1;
  if (categoryA !== categoryB) return categoryA === 'ledger' ? -1 : 1;
  const aIsLedger = categoryA === 'ledger';
  const bIsLedger = categoryB === 'ledger';
  const aIsGroup = categoryA === 'group';
  const bIsGroup = categoryB === 'group';
  if (aIsLedger && bIsLedger) {
    return (a.name || '').toLowerCase().localeCompare((b.name || '').toLowerCase());
  }
  if (aIsGroup && bIsGroup) {
    const orderA = a.displayordernumber ?? 999;
    const orderB = b.displayordernumber ?? 999;
    if (orderA !== orderB) return orderA - orderB;
  }
  const pathA = (a.path || '').toString();
  const pathB = (b.path || '').toString();
  return pathA.localeCompare(pathB);
}

/**
 * Flatten tree for Opening Balance: same order as Trial Balance at each level (ledger first, then group; then restricted, then path).
 */
export const flattenTreeWithLedgersFirst = (tree, page, depth = 1, parentPath = [], parentSide = null) => {
  if (!Array.isArray(tree)) return [];
  const flatList = [];

  const processNodes = (nodes, d, pathArr, side) => {
    if (!Array.isArray(nodes) || nodes.length === 0) return;
    const sortedNodes = [...nodes].sort(sortLedgerFirstThenRestrictedThenPath);

    sortedNodes.forEach((node) => {
      let nodeSide = side;
      if (page !== 'item') {
        if (d === 0) {
          if (node.id === 1 || node.path?.includes(`/1/`)) {
            nodeSide = 'left';
          } else if (node.id === 10 || node.path?.includes(`/10/`)) {
            nodeSide = 'right';
          }
        }
      }
      const newPathArr = [...pathArr, node.id];
      let nodePath = node.path;
      if (page === 'item' && !node.path) {
        nodePath = `/${newPathArr.join('/')}`;
      }
      flatList.push({ ...node, depth: d, side: nodeSide, path: nodePath });
      if (node.children && node.children.length > 0) {
        processNodes(node.children, d + 1, newPathArr, nodeSide);
      }
    });
  };

  const sortedRoot = [...tree].sort(sortLedgerFirstThenRestrictedThenPath);
  sortedRoot.forEach((node) => {
    let side = parentSide;
    if (page !== 'item') {
      if (depth === 0) {
        if (node.id === 1 || node.path?.includes(`/1/`)) {
          side = 'left';
        } else if (node.id === 10 || node.path?.includes(`/10/`)) {
          side = 'right';
        }
      }
    }
    const newPathArr = [...parentPath, node.id];
    let nodePath = node.path;
    if (page === 'item' && !node.path) {
      nodePath = `/${newPathArr.join('/')}`;
    }
    flatList.push({ ...node, depth, side, path: nodePath });
    if (node.children && node.children.length > 0) {
      processNodes(node.children, depth + 1, newPathArr, side);
    }
  });

  return flatList.map(({ children, ...rest }) => rest);
};


export function deepEqual(obj1, obj2) {
  if (obj1 === obj2) return true;

  if (obj1 == null || obj2 == null) return obj1 === obj2;

  if (typeof obj1 !== typeof obj2) return false;

  if (typeof obj1 !== 'object') return obj1 === obj2;

  if (Array.isArray(obj1) !== Array.isArray(obj2)) return false;

  if (Array.isArray(obj1)) {
    if (!Array.isArray(obj2) || obj1.length !== obj2.length) return false;
    for (let i = 0; i < obj1.length; i++) {
      if (!deepEqual(obj1[i], obj2[i])) return false;
    }
    return true;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2 ?? {});

  if (keys1.length !== keys2.length) return false;

  for (let key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false;
    }
  }

  return true;
}
